/**
 * Services icon: barbershop pole.
 * Uses the provided barber pole icon image.
 */
export default function ServicesIcon({ size = 20, style = {} }) {
  return (
    <img
      src="/icons/services-icon.png"
      alt=""
      width={size}
      height={size}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain', imageRendering: '-webkit-optimize-contrast', ...style }}
    />
  );
}
